/**
 *
 * PortalHeader
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 19-Oct-2022
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PortalAppBar from '../PortalAppBar';
import PortalDrawer from '../PortalDrawer';
import { getObjBankInServicing } from 'utils/strings';
import { formatMessage } from 'utils/globalMethods';
import { useLocation, useNavigate } from 'react-router-dom';

const PortalHeader = (props) => {
  // location used to extract the path and highlight the navigation position
  const location = useLocation();
  const navigate = useNavigate();
  const positionName = props.bank ? getObjBankInServicing(props.bank, 'positionName') : '';
  const positionNameId = positionName ? { id: positionName } : '';
  // split the path to extract the right path
  const splitPath = location.pathname.split('/');
  const path = splitPath[splitPath.length - 1];
  // state
  const [openHeaderNavigation, setOpenHeaderNavigation] = useState(false);
  // for accessibility: allows you to open the dropdown from the keyboard
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      // check the key pressed "Enter" o "Space"
      event.preventDefault();
      handleNav(); // open or clod drower
    }
  };

  const handleNav = () => {
    setOpenHeaderNavigation(!openHeaderNavigation);
  };

  const openSwitchPositionModal = () => {
    props.actions.doSwitchPosition({
      bank: props.bank,
      currentPosition: props.currentPosition,
      allPosition: props.positionList,
    });
  };

  return (
    <>
      <PortalAppBar
        switchPositionFunc={openSwitchPositionModal}
        handleOpenDrawerFunction={handleNav}
        handleKeyDropDown={handleKeyDown}
        drawerOpen={openHeaderNavigation}
        currentPositionLabel={
          positionName ? formatMessage(positionNameId) : props?.currentPositionDetails?.userType
        }
        currentPositionValue={props?.currentPositionDetails?.userIdDesc}
        hasNoHeader={props.hasNoHeader}
        enableData={props.receivedData}
        tenantName={props.tenantName}
        projectName={props.projectName}
        bank={props.bank}
        pathLogoNavigation={props.logoNavigation}
        positionArray={props.positionList}
        multiplePosition={props.haveMultiplePosition}
        theme={props.theme}
      />
      {/* drawer */}
      <PortalDrawer
        handleOpenDrawerFunction={handleNav}
        drawerOpen={openHeaderNavigation}
        locationPath={path}
        currentPositionLabel={
          positionName ? formatMessage(positionNameId) : props?.currentPositionDetails?.userType
        }
        currentPositionValue={props?.currentPositionDetails?.userIdDesc}
        planList={props.planList}
        serviceList={props.serviceList}
        multiplePosition={props.haveMultiplePosition}
        switchPositionFunc={openSwitchPositionModal}
        packageId={props.packageId}
        serviceId={props.serviceId}
        subscribeStatus={props.subscribeStatus}
        hasButton={props.bank ? getObjBankInServicing(props.bank, 'hasExplicitLogout') : ''}
      />
    </>
  );
};

PortalHeader.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  logoNavigation: PropTypes.string,
  hasNoHeader: PropTypes.bool,
  receivedData: PropTypes.bool,
  currentPositionDetails: PropTypes.object,
  planList: PropTypes.array,
  serviceList: PropTypes.array,
  haveMultiplePosition: PropTypes.bool,
  tenantName: PropTypes.string,
  projectName: PropTypes.string,
  positionList: PropTypes.array,
  actions: PropTypes.object,
  currentPosition: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  packageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  serviceId: PropTypes.string,
  bank: PropTypes.string,
  subscribeStatus: PropTypes.string,
  theme: PropTypes.object,
};

PortalHeader.defaultProps = {
  // Add here some default propTypes values
  hasNoHeader: false,
  logoNavigation: '/',
  receivedData: false,
  planList: [],
  serviceList: [],
  tenantName: '',
  projectName: '',
  positionList: [],
  actions: {},
  currentPositionDetails: {},
  currentPosition: '',
  packageId: '',
  serviceId: '',
  bank: '',
  subscribeStatus: '',
  theme: {},
};

export default PortalHeader;
